import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/lifetimeValueByMembershipsSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector(
    (state) => state.lifetimeValueByMembership.selectedRequestDates
  );
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.lifetimeValueByMembership.currentUser
  );

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(actionCreators.updateDates({ startDate, endDate }));
  };

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      minDate={calendarStartDate}
      updateDates={handleUpdateDates}
    />
  );
};

export default DatePicker;
